import { TextField, TextFieldProps, TextFieldType } from "./text-field";
import { ComponentInterfaceBaseClass } from "@att-bit/duc.utils-ts.types";
import React from 'react';

export class TextFieldInterface extends ComponentInterfaceBaseClass implements TextFieldProps {
       
       autocompleteOption?: string;
       disableCopyPaste?: boolean;
       disabled?: boolean;
       error?: boolean;
       errorText?: string;
       hasEye?: boolean;
       hintText?: string;
       labelText?: string;
       maxLength?: number;
       name?: string;
       placeHolder?: string;
       showHidePassword?: boolean;
       tooltip?: React.ReactNode;
       type?: TextFieldType;
      // onChange?: () => void;
      // onKeyPress?: () => void;

    static initWithSanity(key, feed) {
        const t = new TextFieldInterface();
        t.autocompleteOption = feed?.autocompleteOption;
        t.disableCopyPaste = feed?.disableCopyPaste;
        t.disabled = feed?.disabled;
        t.error = feed?.error;
        t.errorText = feed?.errorText;
        t.hasEye = feed?.hasEye;
        t.hintText = feed?.hintText;
        t.labelText = feed?.labelText;
        t.maxLength = feed?.maxLength;
        t.name = feed?.name;
        t.placeHolder= feed?.placeHolder;
        t.showHidePassword = feed?.showHidePassword
        t.tooltip = feed?.tooltip;
        return t;
    }
    
    toProps(textfieldRuntimeProps): TextFieldProps {
        return {
            autocompleteOption : this.autocompleteOption,
            disableCopyPaste : this.disableCopyPaste,
            disabled : this.disabled,
            error : this.error,
            errorText : this.errorText,
            hasEye : this.hasEye,
            hintText : this.hintText,
            labelText : this.labelText,
            maxLength : this.maxLength,
            name : this.name,
            placeHolder: this.placeHolder,
            showHidePassword : this.showHidePassword,
            tooltip : this.tooltip,
            ...textfieldRuntimeProps,
           // onChange: onChange,
           // onKeyPress: onKeyPress
        }
    }

    toJsx(textfieldRuntimeProps: React.InputHTMLAttributes<HTMLInputElement>): JSX.Element {
        return React.createElement(TextField, {
            ...this.toProps(textfieldRuntimeProps), 
        });
    }
}